import React from "react";
import * as ReactDOM from "react-dom";

require('element.scrollintoviewifneeded-polyfill');

export default class ObjectList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sort: 'number',
            direction: 1
        };
    }

    handleClick(object) {
        this.props.onObjectClick(object);
    }

    handleMouseEnter(object) {
        this.props.onObjectMouseEnter(object);
    }

    scrollElementIntoViewIfNeeded(domNode) {
        domNode.scrollIntoViewIfNeeded();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.hoverObject !== this.props.hoverObject) {
            if (this.refs.hoverObject) {
                const domNode = ReactDOM.findDOMNode(this.refs.hoverObject);
                this.scrollElementIntoViewIfNeeded(domNode);
            }
        }
    }

    handleMouseLeave(object) {
        this.props.onObjectMouseLeave(object);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.sort !== nextState.sort || this.state.direction !== nextState.direction) {
            return true;
        }

        if (this.props.hoverObject !== nextProps.hoverObject) {
            return true;
        }

        if (this.props.height !== nextProps.height) {
            return true;
        }

        if (this.props.width !== nextProps.width) {
            return true;
        }

        if (this.props.visibleRooms !== nextProps.visibleRooms) {
            return true;
        }

        return false;
    }

    setSorting(column) {
        if (this.state.sort === column) {
            this.setState({sort: column, direction: (this.state.direction === 1 ? -1 : 1)});
        } else {
            this.setState({sort: column, direction: 1});
        }
    }

    render() {
        if (!this.props.height) {
            return false;
        }

        const style = {
            height: this.props.height + 'px',
        };


        const sortedObjects = [].concat(this.props.objects)
            .sort((a, b) => {
                if (this.state.sort === 'number'
                    || this.state.sort === 'living_area'
                    || this.state.sort === 'floor_number'
                    || this.state.sort === 'price'
                    || this.state.sort === 'rooms'
                    || this.state.sort === 'monthly_fee') {
                    const an = parseInt(a[this.state.sort], 10),
                        bn = parseInt(b[this.state.sort], 10);

                    if (an > bn) return this.state.direction;
                    else if (an < bn) return -1 * this.state.direction;
                    return 0;
                }
            });

        const state = this.state;
        function sortableClass(col) {
            if (state.sort === col) {
                return ' sort' + (state.direction === 1 ? ' asc' : '');
            }
            return '';
        }

        return (
            <div className="cw-object-list">
                <div className="cw-object-list-head">
                    <div className="list-row">
                        <div className={'col col-status'}></div>
                        <div className={'col col-number' + sortableClass('number')}><a
                            onClick={() => this.setSorting('number')}>Lgh</a></div>
                        <div className={'col col-floor' + sortableClass('floor_number')}><a
                            onClick={() => this.setSorting('floor_number')}>Vån.</a></div>
                        <div className={'col col-area' + sortableClass('living_area')}><a
                            onClick={() => this.setSorting('living_area')}>KVM.</a></div>
                        <div className={'col col-rooms' + sortableClass('rooms')}><a
                            onClick={() => this.setSorting('rooms')}>ROK</a></div>
                        <div className={'col col-fee' + sortableClass('monthly_fee')}><a
                            onClick={() => this.setSorting('monthly_fee')}>Avgift</a></div>
                        <div className={'col col-price' + sortableClass('price')}><a
                            onClick={() => this.setSorting('price')}>Pris</a></div>
                    </div>
                </div>

                <div className="cw-object-list-body" style={style}>
                    {sortedObjects.map(object => {
                        const isHoverObject = this.props.hoverObject === object
                        if (object.status_id === 6) {
                            return null;
                        }

                        const hidden = this.props.visibleRooms.indexOf(object.rooms) === -1;
                        let className = isHoverObject && !hidden ? 'list-row active' : 'list-row';
                        if (hidden) {
                            className += ' hidden';
                        }
                        className += ' list-row-status-' + object.status_id;

                        return (<div className={className} key={object.id}
                                     ref={isHoverObject ? 'hoverObject' : ''}
                                     onClick={() => this.handleClick(object)}
                                     onMouseEnter={() => this.handleMouseEnter(object)}
                                     onMouseLeave={() => this.handleMouseLeave(object)}>
                            <div className="col col-status">
                                <span className={'status-blob status-blob-' + object.status_id}></span></div>
                            <div className="col col-number">{object.number}</div>
                            <div className="col col-floor">{object.floor_number}</div>
                            <div className="col col-area">{object.living_area_format} <span className="hidden-xs-down">m<sup>2</sup></span>
                            </div>
                            <div className="col col-rooms">{object.rooms}</div>
                            <div className="col col-fee">{object.monthly_fee_format} kr</div>
                            <div className="col col-price">{object.price_format} kr</div>
                        </div>)
                    })}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ObjectList.jsx